import get from 'lodash/get';
import {
  FETCH_RENTAL_GROUPS,
  FETCH_RENTAL_GROUPS_FAILURE,
  FETCH_RENTAL_GROUPS_SUCCESS,
} from './types';

const initialState = {
  isRentalGroupsLoading: false,
};

const rentalGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RENTAL_GROUPS: {
      return {
        ...state,
        isRentalGroupsLoading: true,
      };
    }

    case FETCH_RENTAL_GROUPS_SUCCESS: {
      const resData = get(action, 'response', []);
      resData.rows.sort(function (a, b) {
        return a.id - b.id;
      });
      return {
        ...state,
        rentalGroupList: resData.rows,
        isRentalGroupsLoading: false,
      };
    }

    case FETCH_RENTAL_GROUPS_FAILURE: {
      return {
        ...state,
        isRentalGroupsLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default rentalGroupReducer;
